import React from 'react';
import { Reveal } from './Reveal';
import { bonos } from '../constants/data';
export function Bonos() {
  return <section className="w-full px-5 py-16 sm:py-24" style={{
    backgroundColor: '#0D0D0D'
  }} data-id="element-16">
      <div className="mx-auto max-w-5xl" data-id="element-17">
        <Reveal data-id="element-18">
          <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold" data-id="element-19">
            🎁 Los 3 Bonos — Incluidos Siempre
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-20">
          {bonos.map((bono, i) => <Reveal key={bono.number} delay={i * 0.1} data-id="element-21">
              <article className="glass glass-hover h-full p-6 flex flex-col" data-id="element-22">
                <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold text-base" style={{
              backgroundColor: `${bono.color}22`,
              color: bono.color
            }} data-id="element-23">
                  {bono.number}
                </div>
                <h3 className="mt-4 text-lg font-bold text-white" data-id="element-24">
                  {bono.name}
                </h3>
                <p className="mt-2 text-sm text-white/60 flex-1" data-id="element-25">
                  {bono.description}
                </p>
                <div className="mt-4 flex items-center gap-3" data-id="element-26">
                  <span className="text-sm line-through" style={{
                color: '#FF3B30'
              }} data-id="element-27">
                    {bono.oldPrice}
                  </span>
                  <span className="text-xs font-bold px-2.5 py-1 rounded-full" style={{
                backgroundColor: 'rgba(0,200,83,0.15)',
                color: '#00C853'
              }} data-id="element-28">
                    GRATIS
                  </span>
                </div>
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.2} data-id="element-29">
          <div className="mt-8 glass p-6 flex flex-col items-center text-center" data-id="element-30">
            <span className="text-sm text-white/60" data-id="element-31">
              Valor total de los 3 Bonos
            </span>
            <span className="mt-1 text-2xl sm:text-3xl font-bold line-through" style={{
            color: '#FF3B30'
          }} data-id="element-32">
              $34.000 ARS
            </span>
            <span className="mt-3 text-sm sm:text-base font-bold px-4 py-2 rounded-full" style={{
            backgroundColor: 'rgba(0,200,83,0.15)',
            color: '#00C853'
          }} data-id="element-33">
              🎁 GRATIS — Siempre incluidos
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}